import api from "./axios";

export const getSystemList = () =>
    api.get("/system_list");

export const getSystem = (systemId) =>
    api.get(`/system/${systemId}`);

export const getBranchList = (systemId) =>
    api.get(`/branch_list/${systemId}`);

export const getBranch = (branchId) =>
    api.get(`/branch/${branchId}`);
